import styled from 'styled-components'

export const Canvas = styled.canvas`
  display: ${props => (props.mobileOff ? 'none' : 'block')};
  overflow: hidden;
  ${props => props.theme.mediaQueries.tablet} {
    position: absolute;
    display: block;
  }
`
